function drawPath(path, duration) {
    path.style.transitionDuration = `${duration}s`
    path.style.strokeDashoffset = 0
}

export default drawPath